import { getHomePageUrl } from 'utils/navigation';

export const instructionBreadcrumbs = (): any => [
  {
    href: getHomePageUrl(),
    label: 'Начало',
  }
];